/**
 * Handles country detection and updates store switcher UI
 */

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(";")
      .shift();
  return null;
}

function updateStoreSwitcherUI(detectedCountry) {
  const storeSwitchers = document.querySelectorAll(".store-switcher");

  storeSwitchers.forEach((switcher) => {
    const storeSelect = switcher.querySelector(".store-select");
    if (!storeSelect) return;

    const storeOptions = switcher.querySelectorAll(
      ".z-storeSelector a[data-country-code]"
    );

    let matchingOption = Array.from(storeOptions).find(
      (option) => option.getAttribute("data-country-code") === detectedCountry
    );

    if (!matchingOption) {
      matchingOption = Array.from(storeOptions).find(
        (option) => option.getAttribute("data-country-code") === "FR"
      );
    }

    if (matchingOption) {
      const flag = matchingOption.querySelector("img");
      const countrySpan = matchingOption.querySelector("span:first-of-type");
      const currencySpan = matchingOption.querySelector("span:last-of-type");

      const selectFlag = storeSelect.querySelector("img");
      const selectCountrySpan = storeSelect.querySelector("span:first-of-type");
      const selectCurrencySpan = storeSelect.querySelector("span:last-of-type");

      if (flag && selectFlag) selectFlag.src = flag.src;
      if (countrySpan && selectCountrySpan)
        selectCountrySpan.textContent = countrySpan.textContent;
      if (currencySpan && selectCurrencySpan)
        selectCurrencySpan.textContent = currencySpan.textContent;

      storeSelect.setAttribute(
        "data-country-code",
        matchingOption.getAttribute("data-country-code")
      );
      storeSelect.setAttribute(
        "data-currency",
        matchingOption.getAttribute("data-currency")
      );
    }
  });
}

function initCountryDetection() {
  const hasLocationCookie = getCookie("store_location_selected");
  const localVal = localStorage.getItem('store_location_selected');

  if (!hasLocationCookie && !localVal) {
    fetch("https://ipinfo.io/json?token=9c3d87f4e9efa7")
      .then((response) => response.json())
      .then((jsonResponse) => {
        if (jsonResponse.country) {
          updateStoreSwitcherUI(jsonResponse.country);
        }
      })
      .catch((error) => {
        updateStoreSwitcherUI("FR");
      });
  }
}

document.addEventListener("DOMContentLoaded", initCountryDetection);
